<template>
    <div class="home" style="width: 100%">
        <AuthCheck :show="show" :is_auth="is_auth" :is_auth_check="is_auth_check" :userData="userData" :isHome="true"
            @goEdit="goEdit" />
        <completeInformation v-if="show" :isAuthCheck="isEdit" :userData="userData" />
    </div>
</template>

<script>
import completeInformation from '../../components/completeInformation.vue'
import AuthCheck from '../../components/AuthCheck.vue'
import { api6 } from '@/api/index.js'
export default {
    data() {
        return {
            show: false,
            is_auth: null,
            is_auth_check: null,
            isEdit: true,
            userData: {}
        }
    },
    components: { completeInformation, AuthCheck },
    mounted() {
        this.qx()
    },
    methods: {
        goEdit() {
            this.show = true;
        },
        qx() {
            api6({ id: JSON.parse(localStorage.getItem('userInfo')).id }).then(res => {
                console.log(res, 'resresres');

                if (res.data.code === 1) {
                    // 1:已认证  0：未认证
                    this.is_auth = res.data.data.user.is_auth
                    this.is_auth_check = res.data.data.user.is_auth_check
                    this.isEdit = (res.data.data.user.is_auth_check === 1 || res.data.data.user.is_auth_check === 2) && this.is_auth === 1
                    let data = res.data.data.user
                    data.qd = this.setImgList(data.qd)
                    data.engineer_file = this.setImgList(data.engineer_file)
                    data.honor = this.setImgList(data.honor)
                    data.business = this.setImgList(data.business)
                    data.coop_file = this.setImgList(data.coop_file)
                    data.xinyong = this.setImgList(data.xinyong)
                    this.userData = data
                    this.goEdit()
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        setImgList(data) {
            console.log(data)
            console.log(data.length)

            let newData = []
            if (data && data.length > 0) {
                data.forEach(e => {
                    console.log(e)
                    newData.push({
                        url: e,
                        name: e
                    })
                });
            }
            console.log(newData)
            return newData

        }

    }
}
</script>

<style>
.text2 {
    font-weight: 400;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 28px;
}

.text1 {
    font-weight: 400;
    font-size: 40px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 41px;
}

.homepic {
    width: 328px;
    height: 379px;
}

.home {
    width: 100%;
    height: 100%;
    background: #fff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/view/MY/edit.vue